import * as React from "react";
import { scaleLinear, scaleBand } from "@vx/scale";
import { max } from "d3-array";
import { Group } from "@vx/group";
import { Bar } from "@vx/shape";
import { AxisBottom } from "@vx/axis";

export type ChartData = {
  id: number;
  name: string;
  total: number;
  delta: number;
};

export interface Props {
  width: number;
  height: number;
  data: ChartData[];
  active: number;
  onClick: (index: number) => void;
}

export default function BarChart({ width, height, data, active, onClick }: Props) {
  const margin = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };

  // accessors
  const x = (d: ChartData) => d.name;
  const y = (d: ChartData) => d.total;
  const y2 = (d: ChartData) => d.delta;

  const xMax = width - margin.left - margin.right;
  const yMax = height - margin.top - margin.bottom;

  // // scales
  let maxV = max(data.map(y));
  const yScale = scaleLinear({
    rangeRound: [0, yMax],
    domain: [0, maxV || 1],
    nice: true
  });
  const xScale = scaleBand({
    rangeRound: [0, xMax],
    domain: data.map(x)
  });

  return (
    <div>
      <svg width={width} height={height}>
        {data.map((d, i) => {
          const barHeight = yScale(y(d)) as number;
          const barHeight2 = yScale(y2(d)) as number;

          const barWidth = Math.max(xScale.bandwidth() - 2, 0);
          const xCoord = xScale(x(d));
          return (
            <Group key={`bar-${i}`} top={margin.top} left={margin.left}>
              <Bar
                y={0}
                x={xCoord}
                height={height}
                width={barWidth}
                rx={4}
                fill={active === d.id ? "#2D3748" : "#4A5568"}
                opacity={0.4}
                onClick={() => {
                  onClick(d.id);
                }}
              />
              <Bar
                y={height - margin.bottom - barHeight - margin.top}
                x={xCoord}
                height={barHeight}
                width={barWidth}
                rx={4}
                fill={active === d.id ? "#f67280" : "#A0AEC0"}
                onClick={() => {
                  onClick(d.id);
                }}
              />
              <Bar
                y={height - margin.bottom - barHeight2 - margin.top}
                x={xCoord}
                height={barHeight2}
                width={barWidth}
                rx={0}
                fill={"#67C98F"}
                onClick={() => {
                  onClick(d.id);
                }}
              />
            </Group>
          );
        })}
      </svg>
    </div>
  );
}
